export const PASSWORD_REGEX = /[0-9a-zA-Z\- !"#$%&'()*+,./:;<=>?@\][\\^_`{|}~]/;
